<!--
 * @Author: your name
 * @Date: 2020-10-26 09:18:56
 * @LastEditTime: 2021-09-12 15:38:03
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \admin\src\App.vue
-->
<template>
  <div id="app">
    <public-head v-if="!['/login'].includes($route.path)"></public-head>
    <transition :name="transitionName" mode="out-in">
      <router-view></router-view>
    </transition>
    <public-footer v-if="!['/login'].includes($route.path)"></public-footer>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      transitionName: ""
    };
  },
  watch: {
    //使用watch 监听$router的变化
    $route(to, from) {
      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if (to.meta.index > from.meta.index) {
        //设置动画名称
        this.transitionName = "slide-left";
      } else {
        this.transitionName = "slide-right";
      }
    }
  }
};
</script>

<style lang="less" scoped>
#app {
  min-width: 800px;
  overflow: hidden;
}
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 500ms;
  position: absolute;
  width: 100%;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-30px, 0, 0);
}
.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(30px, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(30px, 0, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-30px, 0, 0);
}

// //转场动画
// .slide-right-enter-active,
// .slide-right-leave-active,
// .slide-left-enter-active,
// .slide-left-leave-active {
//   // 启用硬件加速
//   will-change: transform;
//   transition: all 300ms;
//   position: fixed;
// }
// .slide-right-enter {
//   transform: translate(-100%, 0);
//   transition-timing-function: ease-in;
// }
// .slide-left-enter {
//   transform: translate(100%, 0);
//   transition-timing-function: ease-in;
// }
</style>



// WEBPACK FOOTER //
// src/App.vue